<template>
  <div>
    <CurrentStockAdjustTemp goods-option="S0102" goods-type="반제품"/>
  </div>

</template>

<script>
import CurrentStockAdjustTemp from './CurrentStockAdjustTemp'
export default {
  name: 'CurrentSemiProductionStockAdjust',
  data: function () {
    return {
    }
  },
  components: {
    CurrentStockAdjustTemp
  },
  created () {
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
